// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/default').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/default/build.source.js
// module id = 273
// module chunks = 2